import React from 'react';
import classNames from 'classnames';
import { RuleStepEvaluation } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Debugging/DebugData/RuleStepEvaluation';
import { StepEvaluation } from './StepEvaluation';
import './ListStepEvaluationItem.less';

export interface ListStepEvaluationItemProps {
  className?: string;
  evaluation: RuleStepEvaluation;
  index: number;
  hasSkippedAbove?: boolean;
  hasSkippedBelow?: boolean;
}

export function ListStepEvaluationItem({
  index,
  evaluation,
  hasSkippedAbove,
  hasSkippedBelow,
}: ListStepEvaluationItemProps) {
  //TODO alex: move index out of StepEvaluation and put it here
  return (
    <li
      value={index}
      className={classNames('dpc-list-step-evaluation__item', {
        'dpc-list-step-evaluation__item--skipped-above': hasSkippedAbove,
        'dpc-list-step-evaluation__item--skipped-below': hasSkippedBelow,
      })}
    >
      <StepEvaluation evaluation={evaluation} index={index} />
    </li>
  );
}
